export const getTenantList = state => {
    return state.list
}

export const getTenantDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/tenants/getters.js